import { Component, OnInit, AfterViewInit, Input, ViewChild, ElementRef, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { LwSwitchMainGraph } from '../../lw-graphs/switch-main';
import { selectAll } from 'd3';
import { DemoAccountService } from '../../../demo-account.service';
import { time } from '../../../services/global-variables.service';
import { ChartJsSwitchGraph } from '../../lw-graphs/chart-js-switch';
import { ActiveGraphService } from '../../active-graph.service';
import { Chart } from 'chart.js';

@Component({
    selector: 'lds-y3-switch-graphs',
    templateUrl: './y3-switch-graphs.component.html',
    styleUrls: ['./y3-switch-graphs.component.css'],
    standalone: false
})
export class Y3SwitchGraphsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() data: any;
  @Input() status: string;
  @Input() timespan: string;
  @Input() startTime;
  @Input() endTime;
  
  @ViewChild('graph', {static: false}) graphArea: ElementRef;
  graph: any;
  loading = true;
  demoValue;
  constructor(private demo: DemoAccountService, private activeGraphs: ActiveGraphService) { }

  ngOnInit() {
  }

  ngOnDestroy(){
    if(this.graph){
      this.graph.destroy();
    }
  }

  ngOnChanges(changes: SimpleChanges) {

    const chartExists = Chart.getChart("graph");
    if(chartExists){
      chartExists.destroy();
    }

    selectAll('.SD-graph-main > .SD-graph > svg').remove();

    if (changes.data && !changes.data.firstChange) {

        const range = this.timespan === 'monthly' ? 30 : 7;
        const { data } = changes;
        if (!data.currentValue.length) {
          data.currentValue = [{
            timestamp: this.startTime ? this.startTime :  (Date.now() - time.day * range),
            value: this.status === 'on' ? 1 : 0
          }, {
            timestamp: this.endTime ? this.endTime : Date.now(),
            value: this.status === 'on' ? 1 : 0
          }];
        }

        let graph = new ChartJsSwitchGraph();
        this.loading = false;
        this.activeGraphs.graph = graph.graph;
        graph.draw(data.currentValue);
        
        this.graph = graph.graph;
    }
  }

  resetGraph(){
    this.graph.resetZoom();
  }
}
